import { Injectable } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

import { UsersApiService } from '@app/shared/services/users/users-api.service';

@Injectable()
export class DuplicateEmailValidator {
  debouncer: any;

  constructor(private usersApiService: UsersApiService) {}

  public checkEmail(control: UntypedFormControl): any {
    clearTimeout(this.debouncer);

    return new Promise((resolve) => {
      this.debouncer = setTimeout(() => {
        this.usersApiService.duplicateEmailCheck(control.value).subscribe(
          (res) => {
            if (res.ok) {
              resolve(null);
            }
          },
          (err) => {
            resolve({ duplicate: true });
          },
        );
      }, 500);
    });
  }
}
